export default __webpack_public_path__ + "banner-framework-ab7d26cb.png";